import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const WideButtonStyled = styled('div')`
  width: ${({big})=> big ? 'auto' : '207px'};
  height: ${({big})=> big ? '50px' : '40px'};
  border-radius: ${({big})=> big ? '27px' : '22px'};
  ${({big})=> big && `
    min-width:207px;
    padding-right: 10px;
  `};
  box-shadow: 0px 1px 7px 0 rgba(0, 105, 250, 0.15);
  background-color: rgb(249, 249, 249);
  border: solid 1px #a2adc4;
  display: flex;
  margin-right: 10px;
  cursor: pointer;
  font-size: 12px;
`;

const ContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 90%;
  padding: 3px;
`;

const BoxNumber = styled('div')`
  font-family: Heebo-light;
  font-size: 16px;
  font-weight: 300;
  width: 22px;
  height: ${({big})=> big ? '42px' : '32px'};
  color: rgb(88, 103, 132);
  padding: 6px;
  background-color: #e4edf7;
  border: solid 0px transparent;
  border-radius: 22px 0 0 22px;
  margin: 3px 5px;
`;

const BoxTitle = styled('div')`
  font-family: Heebo;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: rgb(88, 103, 132);
`;

const BoxValue = styled('div')`
  font-family: Heebo-Bold;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  margin-left: 3px;
  color: rgb(88, 103, 132);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const WideButton = props => {
  const {
    title, value, qNumber, clickHandler=()=>{}, big=false
  } = props;
  return (
    <WideButtonStyled onClick={clickHandler} big={big} >
      <BoxNumber big={big}>{`${qNumber || ''}  `}</BoxNumber>
      <ContentWrapper big={big}>
        <BoxTitle>{title}</BoxTitle>
        <BoxValue>{value}</BoxValue>
      </ContentWrapper>
    </WideButtonStyled>
  );
};

WideButton.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
  qNumber: PropTypes.number,
  clickHandler: PropTypes.func,
  big: PropTypes.bool,
};

export default WideButton;
